import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './Projects.css';

interface IProjectsProps {
  title: React.ReactNode;
  tabs: React.ReactNode;
  viewMode: React.ReactNode;
  filters: React.ReactNode;
  content: React.ReactNode;
}

export function Projects({ tabs, viewMode, title, filters, content }: IProjectsProps) {
  return (
    <section id="projects" className={styles['projects']}>
      <Layout>
        <div className={styles['projects__title']}>{title}</div>

        <div className={styles['projects__controls']}>
          {tabs}
          {viewMode}
        </div>

        <div className={styles['projects__filters']}>{filters}</div>

        {content}
      </Layout>
    </section>
  );
}
